<template>
  <div class="unmudl_widget">

    <div id="progressPopupTarget">
      <span style="visibility: hidden;">_^_</span>
    </div>

    <div id="program-list" class="program_list_container">

      <div class="list_heading">With this {{type.toLowerCase()}} you may be eligible for</div>

      <b-tabs v-model="tabIndex">
        <b-tab no-body title="Certificates" :title-link-class="linkClass(0)" title-item-class="w-50 text-center">
          <template v-if="certificates.length > 0">

            <div class="widget_entity_list">

              <div class="tbl_content">
                <div v-for="program in certificates">
                  <div class="row tbl_row" v-if="program.progress">
                    <div class="col-12">

                      <div class="row">
                        <div class="col-4 progress_bar">
                          <b-progress :max="100" height="20px" style="background-color: #d1d1d1 !important;">
                            <b-progress-bar :value="program.completion" :label="`${program.completion}%`"></b-progress-bar>
                          </b-progress>
                        </div>
                        <div class="col-8">
                          <strong>{{program.selectedCredit}}</strong>
                          <template v-if="!isGusetLogin"> selected and <strong>{{program.progress.completed}}</strong> completed </template> out of <strong>{{program.progress.total}}</strong> credits for
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 entity_name">
                         {{program.title}}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                         <b-link class="sec_lnk" @click="showDetails(program)">View Details > </b-link>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </template>

          <template v-else>
            <div class="text-center mt-5">
              <span>No certificates available</span>
            </div>
          </template>

        </b-tab>

        <b-tab no-body title="Degrees" :title-link-class="linkClass(1)" title-item-class="w-50 text-center">
          <template v-if="degrees.length > 0">

            <div class="widget_entity_list">

              <div class="tbl_content">
                <div v-for="program in degrees">
                  <div class="row tbl_row" v-if="program.progress">
                    <div class="col-12">

                      <div class="row">
                        <div class="col-4 progress_bar">
                          <b-progress :max="100" height="20px" style="background-color: #d1d1d1 !important;">
                            <b-progress-bar :value="program.completion" :label="`${program.completion}%`"></b-progress-bar>
                          </b-progress>
                        </div>
                        <div class="col-8">
                           <strong>{{program.selectedCredit}}</strong>
                          <template v-if="!isGusetLogin"> selected and <strong>{{program.progress.completed}}</strong> completed </template> out of <strong>{{program.progress.total}}</strong> credits for
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 entity_name">
                            {{program.title}}
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12">
                         <b-link class="sec_lnk" @click="showDetails(program)">View Details > </b-link>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </template>

          <template v-else>
            <div class="text-center mt-5">
              <span>No degrees available</span>
            </div>
          </template>

        </b-tab>
      </b-tabs>
    </div>

    <template v-if="showProgressPopover && selectedProgram">
      <unmudl-explore-program-progress
        :institution-id="institutionId"
        :course-title="courseTitle"
        :program="selectedProgram" ref="progressDetail">
      </unmudl-explore-program-progress>
    </template>
  </div>

</template>

<script>
  import _ from 'lodash'
  import UnmudlExploreProgramProgress from './UnmudlExploreProgramProgress'
  import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'unmudl-explore-program-list',
    props: ['type', 'programs', 'institutionId', 'courseTitle'],
    components: {
      UnmudlExploreProgramProgress
    },
    data: () => {
      return {
        tabIndex: 0,
        degrees: [],
        certificates: [],
        selectedProgram: null,
        showProgressPopover: false
      }
    },
    mounted () {
      this.programs.forEach((program, i) => {
        if (program.type === 'CERT') {
          this.certificates.push(program)
        } else {
          this.degrees.push(program)
        }
      })
      this.$nextTick(() => {
        window.addEventListener('message', (event) => {
          if (event.data.name === 'LaunchDetailView') {
            $('#program-list').hide()
            setTimeout(() => {
              this.selectedProgram = event.data.data
              this.showProgressPopover = true
            }, 0)
          } else if (event.data.name === 'LaunchCareerProspect') {
            $('#program-list').hide()
            this.selectedProgram = event.data.data
            this.showProgressPopover = true
            setTimeout(() => {
              if (this.$refs.progressDetail) {
                this.$refs.progressDetail.goToCareerProspect(this.selectedProgram)
              }
            }, 0)
          } else if (event.data.name === 'LaunchAddCompletedCourse') {
            $('#program-list').hide()
            this.selectedProgram = event.data.data
            this.showProgressPopover = true
            setTimeout(() => {
              if (this.$refs.progressDetail) {
                this.$refs.progressDetail.openAddCoursePopup(this.selectedProgram)
              }
            }, 0)
          } else if (event.data.name === 'AfterLogIn') {
            let data = event.data.data
            this.$parent.userId = data.id
            this.$parent.firstName = data.firstName
            this.$parent.lastName = data.lastName
            let loggedIn = localStore.getItem('AfterLogIn')
            if (!loggedIn) {
              localStore.setItem('AfterLogIn', 'yes')
              this.$parent.programs = []
              this.$parent.loginUnmudlUser()
              setTimeout(() => {
                let programCode = localStore.getItem('programCode')
                let program = _.find(this.programs, (p) => {
                  return (programCode === p.code)
                })
                if (program) {
                  localStore.removeItem('programCode')
                  let isViewCareerProspect = localStore.getItem('isViewCareerProspectClicked')
                  let isAddCompletedCourse = localStore.getItem('isAddCompletedCourseClicked')
                  if (isViewCareerProspect) {
                    window.parent.postMessage({name: 'ShowCareerProspect', data: program}, '*')
                  } else if (isAddCompletedCourse) {
                    window.parent.postMessage({name: 'ShowAddCompletedCourse', data: program}, '*')
                  }
                }
              }, 500)
            } else {
              localStore.removeItem('AfterLogIn')
            }
          } else if (event.data.name === 'AfterAddCourse') {
            this.$parent.programs = []
            this.$parent.getCourseProgramProgress()
          } else if (event.data.name === 'AfterCloseAddCourse') {
            let data = event.data.data
            let programCode = data.programCode
            this.$parent.programs = []
            this.$parent.getCourseProgramProgress()
            setTimeout(() => {
              let program = _.find(this.$parent.programs, (p) => {
                return (programCode === p.code)
              })
              if (program) {
                window.parent.postMessage({name: 'ShowDetail', data: program}, '*')
              }
            }, 1000)
          } else if (event.data.name === 'AfterReloadWidget') {
            window.location.reload()
          }
        }, false)
      })
    },
    methods: {
      linkClass (idx) {
        if (this.tabIndex === idx) {
          return ['active']
        } else {
          return ['tab-bg-primary']
        }
      },
      showDetails (program) {
        let token = localStore.getItem('token')
        if (token) {
          localStore.setItem('programCode', program.code)
          window.parent.postMessage({name: 'ShowDetail', data: program}, '*')
        } else {
          window.parent.postMessage({name: 'ReloadWidget'}, '*')
          window.location.reload()
        }
      }
    },
    computed: {
      isGusetLogin () {
        return (localStore.getItem('userrole') === 'Guest')
      }
    }
  }
</script>

<style>
  .logo {
    width: auto;
    max-height: 40px;
    max-width: 100%;
  }

  .tab-bg-primary {
    background-color: #532a6e;
  }

  .unmudl_widget .popover {
    top: -20px !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/widget/components/UnmudlExploreProgramList.vue